import type { HelpFile } from '../../types/help'
import { AssignRoleDialogTestIds } from '../../../testids/AssignRoleDialogTestIds'

export const assignRoleDialogHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [AssignRoleDialogTestIds.assignRoleCombobox]:
      'Rolle suchen und auswählen, die diesem Servicekonto zugewiesen werden soll. Bereits zugewiesene Rollen werden nicht angezeigt.',
    [AssignRoleDialogTestIds.assignRoleDialogTitle]: 'Rolle zuweisen',
    [AssignRoleDialogTestIds.assignRoleForm]:
      'Rolle auswählen und absenden, um sie dem Servicekonto zu gewähren.',
    [AssignRoleDialogTestIds.assignRoleInlineError]:
      'Wird angezeigt, wenn die Rolle bereits zugewiesen ist (409). Bitte eine andere Rolle auswählen.',
  },
}
